import React from "react";
import { Calendar } from "lucide-react";

interface Props {
  onChangePeriod: () => void;
  onBack: () => void;
}

export default function EmptyState({ onChangePeriod, onBack }: Props) {
  return (
    <div className="text-center py-14">
      <div className="inline-flex items-center justify-center mb-5 text-ink">
        <Calendar className="w-11 h-11" strokeWidth={1.75} />
      </div>
      <h3 className="text-base font-bold text-ink mb-1.5">No transactions in this period</h3>
      <p className="text-[12.5px] text-ink3 max-w-[420px] mx-auto mb-5 leading-relaxed">
        This account had no activity in the selected period. Try a longer period, or go back to the chart of accounts to pick another account.
      </p>
      <div className="inline-flex gap-2.5">
        <button
          type="button"
          onClick={onChangePeriod}
          className="h-9 px-4 rounded-[10px] text-[12.5px] font-semibold bg-ink text-white border border-ink"
        >
          Change period
        </button>
        <button
          type="button"
          onClick={onBack}
          className="h-9 px-4 rounded-[10px] text-[12.5px] font-semibold bg-white text-ink border border-[#D8DEE6]"
        >
          Back to chart of accounts
        </button>
      </div>
    </div>
  );
}